import React from "react";
import { useTranslation } from "react-i18next";
import TableMain from "../Common/table/TableMain";
import { getLastPage } from "../../utils/getLastPage";
import ReportFilter from "./ReportFilter";
import { ApiHook } from "../../hooks/apiHook";

const ReportsTable = (props) => {
    const { t } = useTranslation();
    const lastPage = getLastPage(props.itemsPerPage, props?.data?.totalCount);

    const headers = [
        t("slno"),
        t("report_id"),
        t("reported_user"),
        t("report_category"),
        t("subject"),
        t("report_status"),
        t("created_on"),
    ];

    const partials = ApiHook.CallReportPartials();

    return (
        <div className="ewallet_table_section">
            <div className="ewallet_table_section_cnt">
                <ReportFilter
                    selectedOptions={props.selectedOptions}
                    setSelectedOptions={props.setSelectedOptions}
                    partials={partials}
                    setCurrentPage={props.setCurrentPage}
                />
                <div className="table-responsive min-hieght-table ticket_system">
                    <TableMain
                        headers={headers}
                        data={props.data?.data}
                        startPage={1}
                        currentPage={props?.data?.currentPage}
                        totalPages={lastPage}
                        setCurrentPage={props.setCurrentPage}
                        type={"report"}
                        itemsPerPage={props.itemsPerPage}
                        setItemsPerPage={props.setItemsPerPage}
                    />
                </div>
            </div>
        </div>
    );
};

export default ReportsTable;
